<template>
  <div>
    <el-dialog
        :title="fullNameTitle"
        :visible.sync="dialogVisible"
        width="700px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="120px"
          :model="attendanceKid.attendanceArriveKids"
          label-position="top"
          ref="attendanceKid"
      >
        <el-row :gutter="20" style="margin-top: 10px">
          <!-- Card Ghi chú chung - trên cùng -->
          <el-col :span="24">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Ghi chú chung</strong>
              </div>

              <div class="shift-row">
                <div class="shift-col shift-note" style="width: 100%;">
                  <div class="shift-media-title">Nội dung ghi chú cho ngày điểm danh</div>
                  <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Chưa có ghi chú"
                      v-model="attendanceKid.attendanceArriveKids.arriveContent"
                      disabled
                  />

                  <!-- Thông tin người tạo / sửa -->
                  <div class="shift-status" style="margin-top: 16px" v-if="attendanceKid.attendanceArriveKids.idCreated != null">
                    <div v-if="attendanceKid.attendanceArriveKids.createdDate !== attendanceKid.attendanceArriveKids.lastModifieDate">
                      Điểm danh lần cuối: <strong>{{ attendanceKid.attendanceArriveKids.lastModifieBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.lastModifieBy !== 'Hệ thống'">
                        Thời gian: {{ attendanceKid.attendanceArriveKids.lastModifieDate | formatDateTime }}</span>
                    </div>
                    <div v-else>
                      Điểm danh: <strong>{{ attendanceKid.attendanceArriveKids.createdBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.createdBy !== 'Hệ thống'">
                        Thời gian: {{ attendanceKid.attendanceArriveKids.createdDate | formatDateTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-divider />
          </el-col>

          <!-- Buổi sáng -->
          <el-col :span="24" v-if="attendanceConfigResponse.morningAttendanceArrive">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Buổi sáng</strong>
              </div>

              <div class="shift-row two-columns">
                <!-- Ảnh đến -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceArriveKids.arriveUrlPictureMorning"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ attendanceKid.attendanceArriveKids.timeArriveKidMorning | formatTime }}</span>
                  </div>
                </div>

                <!-- Ảnh về -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh về</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceLeaveKids.leaveUrlPictureMorning"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ về: <span>{{ attendanceKid.attendanceLeaveKids.timeLeaveKidMorning | formatTime }}</span>
                  </div>
                </div>
              </div>
            </div>
            <el-divider />
          </el-col>

          <!-- Buổi chiều -->
          <el-col :span="24" v-if="attendanceConfigResponse.afternoonAttendanceArrive">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Buổi chiều</strong>
              </div>

              <div class="shift-row two-columns">
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceArriveKids.arriveUrlPictureAfternoon"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ attendanceKid.attendanceArriveKids.timeArriveKidAfternoon | formatTime }}</span>
                  </div>
                </div>

                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh về</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceLeaveKids.leaveUrlPictureAfternoon"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ về: <span>{{ attendanceKid.attendanceLeaveKids.timeLeaveKidAfternoon | formatTime }}</span>
                  </div>
                </div>
              </div>
            </div>
            <el-divider />
          </el-col>

          <!-- Buổi tối -->
          <el-col :span="24" v-if="attendanceConfigResponse.eveningAttendanceArrive">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Buổi tối</strong>
              </div>

              <div class="shift-row two-columns">
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceArriveKids.arriveUrlPictureEvening"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ attendanceKid.attendanceArriveKids.timeArriveKidEvening | formatTime }}</span>
                  </div>
                </div>

                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh về</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceLeaveKids.leaveUrlPictureEvening"
                      placeholder="Chưa có ảnh"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ về: <span>{{ attendanceKid.attendanceLeaveKids.timeLeaveKidEvening | formatTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <!-- Footer chỉ có nút Đóng -->
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialogByButton">
          <i class="el-icon-circle-close" /> Đóng
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import AttendanceService from "@/services/AttendanceService";
import ImageUploader from "@/utils/view/ImageUploader.vue";

export default {
  components: {ImageUploader},
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      attendanceKid: {
        attendanceArriveKids: {
          arriveUrlPicture: ""
        }
      },
      attendanceConfigResponse: {},
      attendanceSave: {},
      fullNameTitle: "",
      loadingButton: false,
      imageUrl: "",
      showUpload: true,
      showPicutreInitial: true,
      dialogVisibleImg: false,
      urlPictureUser: "",
      morningArriveMultipartFile: "",
      morningLeaveMultipartFile: "",
      afternoonArriveMultipartFile: "",
      afternoonLeaveMultipartFile: "",
      eveningArriveMultipartFile: "",
      eveningLeaveMultipartFile: "",

    };
  },
  methods: {
    showPictureOnDevice(url) {
      this.urlPictureUser = url;
      this.dialogVisibleImg = true;
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close", false);
      this.$refs.uploadMorningArrive.clearFiles();
      this.$refs.uploadMorningLeave.clearFiles();
      this.$refs.uploadAfternoonArrive.clearFiles();
      this.$refs.uploadAfternoonLeave.clearFiles();
      this.$refs.uploadEveningArrive.clearFiles();
      this.$refs.uploadEveningLeave.clearFiles();
      // this.morningArriveMultipartFile =  ""
      // this.morningLeaveMultipartFile =  ""
      // this.afternoonArriveMultipartFile =  ""
      // this.afternoonLeaveMultipartFile =  ""
      // this.eveningArriveMultipartFile =  ""
      // this.eveningLeaveMultipartFile =  ""
      this.handleRemove();
      setTimeout(() => {
        this.$refs["attendanceKid"].resetFields();
      }, 300);
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close", false);
      this.$refs.uploadMorningArrive.clearFiles();
      this.$refs.uploadMorningLeave.clearFiles();
      this.$refs.uploadAfternoonArrive.clearFiles();
      this.$refs.uploadAfternoonLeave.clearFiles();
      this.$refs.uploadEveningArrive.clearFiles();
      this.$refs.uploadEveningLeave.clearFiles();
      this.handleRemove();
      setTimeout(() => {
        this.$refs["attendanceKid"].resetFields();
      }, 300);
    },
    /**
     * click change image
     */
    handleChangeUploadMorningArrive(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.morningArriveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveMorningArrive() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.morningArriveMultipartFile = "";
    },
    /**
     * click change image
     */
    handleChangeUploadMorningLeave(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.morningLeaveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveMorningLeave() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.morningLeaveMultipartFile = "";
    },
    /**
     * click change image
     */
    handleChangeUploadAfternoonArrive(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.afternoonArriveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveAfternoonArrive() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.afternoonArriveMultipartFile = "";
    },
    /**
     * click change image
     */
    handleChangeUploadAfternoonLeave(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.afternoonLeaveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveAfternoonLeave() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.afternoonLeaveMultipartFile = "";
    },
    /**
     * click change image
     */
    handleChangeUploadEveningArrive(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.eveningArriveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveEveningArrive() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.eveningArriveMultipartFile = "";
    },
    /**
     * click change image
     */
    handleChangeUploadEveningLeave(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.eveningLeaveMultipartFile = file.raw;
    },
    /**
     * remove image
     */
    handleRemoveEveningLeave() {
      setTimeout(() => {
        this.showPicutreInitial = true;
        this.showUpload = true;
      }, 800);
      this.eveningLeaveMultipartFile = "";
    },
    /**
     * check image before upload
     */
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.raw.size / 1024 / 1024 <= 5;
      if (!isJPG && !isPNG) {
        this.$message.error("Bạn phải chọn định dạng ảnh");
        this.$refs.upload.clearFiles();
        throw "file not valid";
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB!");
        this.$refs.upload.clearFiles();
        throw "over size";
      }
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append("content", this.attendanceKid.attendanceArriveKids.arriveContent);
          if (this.morningArriveMultipartFile !== "") {
            formData.append("morningArriveMultipartFile", this.morningArriveMultipartFile);
          }
          if (this.morningLeaveMultipartFile !== "") {
            formData.append("morningLeaveMultipartFile", this.morningLeaveMultipartFile);
          }
          if (this.afternoonArriveMultipartFile !== "") {
            formData.append("afternoonArriveMultipartFile", this.afternoonArriveMultipartFile);
          }
          if (this.afternoonLeaveMultipartFile !== "") {
            formData.append("afternoonLeaveMultipartFile", this.afternoonLeaveMultipartFile);
          }
          if (this.eveningArriveMultipartFile !== "") {
            formData.append("eveningArriveMultipartFile", this.eveningArriveMultipartFile);
          }
          if (this.eveningLeaveMultipartFile !== "") {
            formData.append("eveningLeaveMultipartFile", this.eveningLeaveMultipartFile);
          }
          this.loadingButton = true;
          AttendanceService.updateArriveContentV2(
              this.attendanceKid.id,
              formData
          )
              .then(() => {
                this.$message({
                  message: "Lưu điểm danh thành công",
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialogByButton(fromData);
                }, 500);
              })
              .catch((err) => {
                console.log(err);
                this.$message({
                  message: "Lưu điểm danh thất bại",
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },
    getDataArriveRowInitial(row, attendanceConfigResponse) {
      this.attendanceConfigResponse = attendanceConfigResponse
      this.attendanceKid = row;
      this.fullNameTitle = "Thông tin điểm danh: " + row.kids.fullName;
    },
  },
};
</script>
<style scoped>
/* Toàn bộ style được tối ưu để giống phiên bản trước */

.shift-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e7ff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
}

.shift-header {
  font-size: 18px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5efff;
}

.shift-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
}

.shift-col.shift-media {
  flex: 0 0 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.shift-media-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  width: 100%;
}

.shift-time {
  margin-top: 10px;
  font-size: 14px;
  color: #3b82f6;
  font-weight: 500;
  width: 100%;
  text-align: center;
}

.shift-col.shift-note {
  flex: 1;
  min-width: 280px;
}

.shift-row.two-columns {
  justify-content: center;
  gap: 60px;
  padding: 0 40px;
}

.shift-status {
  margin-top: 16px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #4b5563;
}

/* Dialog style */
::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  padding: 18px 24px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 22px !important;
  font-weight: 600;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 24px;
}

::v-deep .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  background: #f8fafc;
  padding: 20px 24px !important;
}

::v-deep .el-dialog__footer {
  background: #f1f5f9;
  padding: 16px 24px !important;
  border-top: 1px solid #e2e8f0;
  text-align: right;
}

::v-deep .el-button--danger {
  background: #ef4444;
  border-color: #ef4444;
}

::v-deep .el-button--danger:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.el-divider {
  margin: 20px 0;
  background: #e2e8f0;
}

/* Responsive */
@media (max-width: 768px) {
  .shift-row.two-columns {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    padding: 0 20px;
  }
  .shift-col.shift-media {
    flex: 0 0 auto;
    width: 100%;
    max-width: 220px;
  }
}
</style>